export function getSettingValue(tenant, key) {
  const list = Array.isArray(tenant?.tenantSettings) ? tenant.tenantSettings : [];
  const row = list.find((item) => item?.settingKey === key);
  return row?.settingValue;
}

export function getHomepageHeroSettingValue(tenant, keyName, fallbackValue = null) {
  const homepageValue = getSettingValue(tenant, `homepage.hero_${keyName}`);
  if (homepageValue !== undefined && homepageValue !== null && String(homepageValue).trim() !== "") {
    return homepageValue;
  }

  const legacyValue = getSettingValue(tenant, `branding.hero_${keyName}`);
  if (legacyValue !== undefined && legacyValue !== null && String(legacyValue).trim() !== "") {
    return legacyValue;
  }

  return fallbackValue;
}
